import React, {FC, memo, useState} from "react";
import {StompSessionProvider, useSubscription} from "react-stomp-hooks";
import SendingMessages from "../stomp/SendingMessages";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions} from "../../store/sliceWebsocket";
import {actions as modal} from "../../store/sliceModal";
import {useDispatch, useSelector} from "react-redux";
import {config} from "../../config";
import {fetchRefreshToken} from "../../fetch/AuthRequest";
import {IUser} from "../../store/sliceUser";
import {actions as actionsApp} from "../../store/sliceApp";
import {Spinner} from "react-bootstrap";
import {VideoContainer, VideoImg} from "./Style";

type StompProps = {
    init?: () => void
   // children: React.ReactElement
}
const WebSocketCamera: FC<StompProps> = ({init}) => {

    // const [imgByte, setImgByte] = useState<Uint8Array>(new Uint8Array())
    const dispatch = useDispatch<AppDispatch>();
    // const token: IToken = useSelector((state: IRootState) => state.token)

    function SubscribingComponent () {
        const [imgByte, setImgByte] = useState<Uint8Array>(new Uint8Array())
        const [img64, setImg64] = useState<string>('')
        const [err, setErr] = useState<string>('')
        const user: IUser = useSelector((state: IRootState) => state.user.user)
    //Subscribe to /topic/test, and use handler for all received messages
    //Note that all subscriptions made through the library are automatically removed when their owning component gets unmounted.
    //If the STOMP connection itself is lost they are however restored on reconnect.
    //You can also supply an array as the first parameter, which will subscribe to all destinations in the array
    useSubscription("/topic/cam/" + user.id, (message) => {
        setErr('')
        setImg64(message.body)
       setImgByte(message.binaryBody)
    });
    useSubscription("/topic/cam/error/" + user.id, (message) => {
        setErr(message.body)
        dispatch(modal.showError(message.body))
    });

        // return <div style={{visibility: "hidden"}}/>;
        return <VideoContainer>
            {err.length > 0  && <p>{err}</p>}
            {err.length == 0 && imgByte.byteLength == 0  && <Spinner variant={"primary"}/>}
            {/*{imgByte.byteLength > 0 && <img style={{objectFit: "scale-down"}} src={URL.createObjectURL(new Blob([imgByte]))}/>}*/}
            {img64.length > 0 && <VideoImg src={`data:image/jpeg;base64,${img64}`}/>}

        </VideoContainer>
}

    return (
        <div>
            <StompSessionProvider
                // onConnect={() => {
                //     fetchRefreshToken()
                // }}
                // connectHeaders={stompHeaders()}
                url={`${config.socketVideoUrl}`}
                //All options supported by @stomp/stompjs can be used here
            >
                <SubscribingComponent/>
                <SendingMessages init={init}/>
                {/*<img width={600} height={400} src={URL.createObjectURL(new Blob([imgByte]))}/>*/}
                {/*{children}*/}
            </StompSessionProvider>
        </div>
    )
}


export default memo(WebSocketCamera)

